import { ref, computed, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-265c4194"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search_block"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "over-text"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0,
  class: "model-tags"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "over-text"
};
const _hoisted_8 = {
  class: "over-text"
};
const _hoisted_9 = {
  key: 6
};
const _hoisted_10 = {
  key: 7
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "m-l-12"
}, "删除", -1));
const _hoisted_14 = {
  class: "pagination"
};
import searchBlock from './components/searchBlock.vue';
import SvgIcon from '@/components/SvgIcon';
import addModal from './components/addModal.vue';
import IndicatorSettingModal from './components/IndicatorSettingModal.vue';
import { tableColumn, MODEL_TYPE_MAP, MODEL_CLASS_MAP } from './data';
import { message } from 'ant-design-vue';
import { reportEvent } from '@/common';
import { getThresholdPlanListFetch, deleteThresholdPlanFetch } from '@/api/orderMonitor';
import useProductList from '../hooks/useProductList';
export default {
  __name: 'index',
  setup(__props) {
    const {
      productList,
      isProductListLoading
    } = useProductList();
    const columns = ref(tableColumn);
    const pageIndex = ref(1);
    const pageSize = ref(20);
    const dataTotal = ref(0);
    const tableData = ref([]);
    const loading = ref(false);
    const oldFilter = ref(null);
    const addRef = ref(null);
    const indicatorRef = ref(null);

    // 将产品列表转换为 Map，提升查找性能（从 O(n) 降到 O(1)）
    const productMap = computed(() => {
      var _productList$value;
      const map = new Map();
      (_productList$value = productList.value) === null || _productList$value === void 0 || _productList$value.forEach(product => {
        if (product.dbtId) {
          map.set(product.dbtId, product);
        }
      });
      return map;
    });

    // 合并 loading 状态：产品列表加载中或表格数据加载中
    const combinedLoading = computed(() => loading.value || isProductListLoading.value);

    // 获取状态颜色
    const getStatusColor = status => {
      return status == 1 ? 'nomal-tagbgc-green' : 'nomal-tagbgc-red';
    };

    // 根据 dbtId 列表获取产品名称
    const getProductNames = dbtIds => {
      if (!Array.isArray(dbtIds) || dbtIds.length === 0) {
        return '--';
      }
      const names = dbtIds.map(dbtId => {
        const product = productMap.value.get(dbtId);
        return (product === null || product === void 0 ? void 0 : product.appName) || (product === null || product === void 0 ? void 0 : product.label);
      }).filter(Boolean);
      return names.length > 0 ? names.join(', ') : '--';
    };
    const changePage = (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      reflashTable();
    };
    const onSearch = async param => {
      pageIndex.value = 1;
      const startTime = new Date().getTime();
      const status = await getTable(param);
      const duartion = new Date().getTime() - startTime;
      reportEvent({
        eventName: '_search',
        properties: {
          ui_name: '阈值方案-筛选',
          app_name: '',
          return_duration: duartion,
          query_status: status
        }
      });
    };
    const reflashTable = () => {
      getTable(oldFilter.value);
    };
    const getTable = async params => {
      try {
        loading.value = true;
        const param = {
          ...params,
          pageIndex: pageIndex.value,
          pageSize: pageSize.value
        };
        oldFilter.value = param;
        const {
          code,
          data
        } = await getThresholdPlanListFetch(param);
        if (code === '0') {
          var _data$total;
          tableData.value = (data === null || data === void 0 ? void 0 : data.thresholdSchemeList) || [];
          dataTotal.value = (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0;
          loading.value = false;
          return 'succeed';
        } else {
          loading.value = false;
          return 'failed';
        }
      } catch (e) {
        loading.value = false;
        return 'failed';
      }
    };
    const addRow = row => {
      addRef.value.showModal(row);
    };
    const openIndicatorSetting = record => {
      indicatorRef.value.showModal(record);
    };
    const deleRow = async schemeId => {
      try {
        const {
          code
        } = await deleteThresholdPlanFetch({
          schemeId
        });
        if (code === '0') {
          message.success('删除成功');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '阈值方案',
              element_name: '删除'
            }
          });
          reflashTable();
        }
      } catch (e) {
        message.error('删除失败');
      }
    };
    onMounted(() => {
      getTable();
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(searchBlock, {
        onSearch: onSearch
      }), _createElementVNode("div", null, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => addRow())
      }, {
        default: _withCtx(() => [_createVNode(_unref(SvgIcon), {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        }), _createTextVNode(" 新增阈值方案 ")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_table, {
        columns: columns.value,
        dataSource: tableData.value,
        rowKey: "schemeId",
        size: "small",
        loading: _unref(combinedLoading),
        pagination: false,
        class: "table-content",
        scroll: {
          x: 'max-content'
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _record$modelConfig, _record$scale, _record$dbtIds;
          return [column.dataIndex === 'schemeName' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [record.schemeName ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '300px'
            }
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.schemeName), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(record.schemeName), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'modelConfig' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [(_record$modelConfig = record.modelConfig) !== null && _record$modelConfig !== void 0 && (_record$modelConfig = _record$modelConfig.modelList) !== null && _record$modelConfig !== void 0 && _record$modelConfig.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.modelConfig.modelList, modelType => {
            return _openBlock(), _createElementBlock("span", {
              key: modelType,
              class: _normalizeClass(_unref(MODEL_CLASS_MAP)[modelType])
            }, _toDisplayString(_unref(MODEL_TYPE_MAP)[modelType] || '--'), 3);
          }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'scale' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createTextVNode(_toDisplayString((_record$scale = record.scale) !== null && _record$scale !== void 0 ? _record$scale : '--'), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'remark' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 3,
            placement: "topLeft",
            "auto-adjust-overflow": false,
            overlayStyle: {
              maxWidth: '300px'
            }
          }, _createSlots({
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(record.remark || '--'), 1)]),
            _: 2
          }, [record.remark ? {
            name: "title",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(record.remark), 1)]),
            key: "0"
          } : undefined]), 1024)) : _createCommentVNode("", true), column.dataIndex === 'dbtIds' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 4,
            placement: "topLeft",
            "auto-adjust-overflow": false,
            overlayStyle: {
              maxWidth: '300px'
            }
          }, _createSlots({
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(getProductNames(record.dbtIds)), 1)]),
            _: 2
          }, [(_record$dbtIds = record.dbtIds) !== null && _record$dbtIds !== void 0 && _record$dbtIds.length ? {
            name: "title",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(getProductNames(record.dbtIds)), 1)]),
            key: "0"
          } : undefined]), 1024)) : _createCommentVNode("", true), column.dataIndex === 'enable' ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: _normalizeClass(getStatusColor(record.enable))
          }, _toDisplayString(record.enable == 1 ? '开启' : '关闭'), 3)) : _createCommentVNode("", true), column.dataIndex === 'createTime' ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(record.createTime || '--'), 1)) : _createCommentVNode("", true), column.dataIndex === 'createUser' ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.createUser || '--'), 1)) : _createCommentVNode("", true), column.dataIndex === 'action' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 8
          }, [_createElementVNode("a", {
            onClick: $event => openIndicatorSetting(record)
          }, "指标设置", 8, _hoisted_11), _createElementVNode("a", {
            onClick: $event => addRow(record),
            class: "m-l-12"
          }, "编辑", 8, _hoisted_12), _createVNode(_component_a_popconfirm, {
            title: "确定删除吗?",
            placement: "topRight",
            onConfirm: $event => deleRow(record.schemeId),
            arrowPointAtCenter: ""
          }, {
            default: _withCtx(() => [_hoisted_13]),
            _: 2
          }, 1032, ["onConfirm"])], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[1] || (_cache[1] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        total: dataTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"])])]), _createVNode(addModal, {
        ref_key: "addRef",
        ref: addRef,
        productList: _unref(productList),
        onReflashTable: reflashTable
      }, null, 8, ["productList"]), _createVNode(IndicatorSettingModal, {
        ref_key: "indicatorRef",
        ref: indicatorRef,
        onReflashTable: reflashTable
      }, null, 512)]);
    };
  }
};